import type { ClientType } from '../constants/client-types';
import type { ExperienceRangeKey } from '../constants/experience-ranges';
import type { FeeOptionKey } from '../constants/fee-options';
import type { Service } from '../constants/services';
import type { Sort } from '../constants/sort';

export type FeeSchedule = {
  aum: boolean;
  flatFee: boolean;
  hourly: boolean;
  commission: boolean;
  performance: boolean;
  otherText: string | null;
};

export type Advisor = {
  crd: string;
  firm: string;
  street?: string;
  city: string;
  state: string;
  zip: string;
  aum?: number;
  clients?: number;
  services: Service[];
  fees: FeeSchedule;
  clientTypes: ClientType[];
  regStatus: 'SEC Registered' | 'State Registered';
  regDate?: string;
  filingDate: string;
  otherServices: string | null;
};

export type SearchParams = {
  q: string;
  page?: number;
  services?: Service[];
  fees?: FeeOptionKey[];
  clientTypes?: ClientType[];
  experience?: ExperienceRangeKey[];
  sort?: Sort;
};

export type { Sort } from '../constants/sort';

export type ResolvedDma = {
  dmaCode: string;
  dmaDescription: string;
};

export type SearchResponse = {
  advisors: Advisor[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
  dmaDescription: string | null;
};

export const ADVISOR_SEARCH_PAGE_SIZE = 5;


